<template>
    <div class="grid ls-choose-your-service__container">
        <div class="grid__col-12">
            <h2
                class="ls-align--center ls-condensed ls-margin--top section-title"
                :class="{ 'ls-margin--bottom': screenSize.xs }"
            >
                <span v-if="!isLawnLove">Schedule Your Lawn Treatment</span>
                <span v-else>Lawn Treatment for {{ order.address.street }}</span>
            </h2>

            <p
                v-if="!isLawnLove"
                class="ls-align--center"
                data-font-size="-1"
                style="margin-top: 3px;"
            >
                <span
                    class="ls-bold"
                    :class="{
                        'ls-color--green--color-dodge': isLawnStarter,
                        'll-color-primary': isLawnLove || isHomeGnome,
                    }"
                    >{{ socialProof }} neighbors&nbsp;
                </span>
                <span>in {{ order.address.zip }} already use {{ brand }}. Join them today.</span>
            </p>
            <p v-else class="ls-align--center" data-font-size="-1" style="margin-top: 3px;">
                <span class="ls-bold">{{ socialProof }} people near you&nbsp; </span>
                <span>already use {{ brand }}. Join them today.</span>
            </p>
            <hr />
        </div>

        <div class="grid__col-12">
            <h2 class="ls-condensed ls-margin--bottom section-title section-title--frequency">
                <a
                    v-if="!screenSize.xs"
                    v-ls-track.click="{
                        target: 'order-form--non-mowing',
                    }"
                    class="ls-normal ls-float-right no-mowing-cta"
                    data-font-size="-1"
                    @click.prevent="gotoNonMowing()"
                >
                    <span
                        v-if="!isLawnLove || featureFlags.flags['lawnlove.customerLeads']"
                        class="non-mowing-link"
                        test-id="non-mowing-link"
                    >
                        I'm looking for something else&nbsp;
                        <i class="fa fa-long-arrow-right"></i>
                    </span>
                </a>
                <span>
                    Your custom Lawn Treatment quote<br />
                    <span class="ls-normal" data-font-size="-1">
                        This quote is personalized for you.
                    </span>
                </span>
            </h2>
        </div>

        <div class="grid__col-12" test-id="total-amount">
            <h2 class="ls-margin--bottom ls-margin--top ls-padding--bottom ls-align--center">
                {{ treatmentTotal | lsMoney }} per treatment
            </h2>
            <span class="ls-margin--bottom ls-color--blue" data-font-size="-1"
                >What's included?</span
            >
            <span class="ls-margin--bottom" data-font-size="-1">
                Lawn Treatment includes pre-emergent and post-emergent weed control, and
                fertilization to strengthen grass at its root system which promotes a greener lawn.
                <br /><br />
                Your first treatment will be confirmed and serviced within a three week window.
            </span>
        </div>

        <div v-if="screenSize.xs" class="grid__col-12 ls-align--center ls-margin--bottom">
            <a
                v-ls-track.click="{
                    target: 'order-form--non-mowing',
                }"
                class="no-mowing-cta"
                data-font-size="-1"
                @click.prevent="gotoNonMowing()"
            >
                <span v-if="!isLawnLove || featureFlags.flags['lawnlove.customerLeads']">
                    I'm looking for something else&nbsp;
                    <i class="fa fa-long-arrow-right"></i>
                </span>
            </a>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';
import { mapState, mapGetters, mapActions } from 'vuex';
import * as types from '@/store/types';
import brandMixin from '@/mixins/brand.mixin';

export default {
    mixins: [brandMixin],
    computed: {
        ...mapState(['order', 'screenSize', 'featureFlags']),
        ...mapGetters({
            cartTotals: types.ORDER__GET_CART_TOTALS,
            treatmentTotal: types.ORDER__GET_CART_TREATMENT_TOTAL,
        }),
        socialProof() {
            const lastDigitOfZip = parseInt(_.last(this.order.address.zip), 0);
            return lastDigitOfZip ? lastDigitOfZip + 40 : 40;
        },
        totalPrice() {
            return this.cartTotals.total_amount;
        },
        today() {
            return moment().format('YYYY-MM-DD');
        },
    },
    created() {
        this.updateStartDate(this.today);
    },
    methods: {
        ...mapActions({
            updateStartDate: types.ORDER__UPDATE_START_DATE,
        }),
        gotoNonMowing() {
            this.$router.push({ name: 'nonMowingForm' });
        },
    },
};
</script>

<style lang="scss" scoped>
.no-mowing-cta {
    padding-top: 0.25rem;
    font-weight: 600;
}

.themed-lawnlove {
    .section-title--frequency {
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        align-items: center;
    }

    .non-mowing-link {
        color: $theme-color-gray-dark;
    }
}

.themed-homegnome {
    .section-title--frequency {
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        align-items: center;
    }

    .non-mowing-link {
        color: $theme-color-gray-dark;
    }
}
</style>
